import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/folders.action'
import createFolder from 'api/administration/folders/Create'
import foldersList from 'api/administration/folders/List'
import I18n from '../../../i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { IFolderModel } from 'models/folder.model'

async function getList() {
  return await foldersList()
}

async function handleCreate(data: IFolderModel) {
  return await createFolder(data)
}

function* createFolderEffectSaga(action: any) {
  try {
    // FIRST CREATE THE FOLDER
    const { folder } = action.payload

    yield call(handleCreate, folder)

    // SECOND RELOAD DATA
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.folderCreateSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.folderCreateError'))
    console.log('error: ', error)
  }
}

export function* createFolderWatcherSaga() {
  yield takeLatest(fromActions.CREATE_FOLDER, createFolderEffectSaga)
}
